module.exports = function() {

    return function(stops) {
        return stops.reduce(function(result, stop) {
            if(! stop.anyComingNotifications()) {
                result.push(stop);
            } else {
                // clear the old result due to driver has skipped customers
                result = [];
            }
            return result;
        }, []);
    };

};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/filters/receivedSms.js
 ** module id = 166
 ** module chunks = 1
 **/